export const CREATE_POST_BASE_PATH = '/digital-marketing/posted-content';

export const buildCreatePostPath = (subPath = '') => {
    const normalizedSubPath = subPath.replace(/^\/+/, '');

    return normalizedSubPath
        ? `${CREATE_POST_BASE_PATH}/${normalizedSubPath}`
        : CREATE_POST_BASE_PATH;
};
